module.exports = __webpack_public_path__ + "img/second_wave_bottom.09b57e64.svg";